import React from "react";
import { Congratulations } from "@resources";
import { useLocation, useNavigate } from 'react-router-dom';
import { Constants, helpers } from "@shared";
import currency from "currency.js";
import { useSpinnerContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';

const SignupCompleted = () => {

    const { setSpinnerShow } = useSpinnerContext();
    const navigate = useNavigate();
    const location = useLocation();
    const { state: { dueDay, autoPay, invitation, defaultPaymentMethod } } = location;

    const paymentDate = helpers.compoundDay(invitation.invoice.dueDate, dueDay);
    const temp = new Date();
    const today = new Date(`${temp.getFullYear()}/${temp.getMonth() + 1}/${temp.getDate()}`);
    const late = paymentDate < today;

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    const makePayment = async () => {

        setSpinnerShow(true);
        try {
            const response = await sunboundPayProxy.getPayorTasks();
            helpers.navigateNext(location, navigate, undefined, {
                defaultPaymentMethod,
                flow: Constants.Flows.justPay.id,
                currentBill: response.currentBill
            });
        } catch (error) {
            console.error(error);
        }
        setSpinnerShow(false);



    };

    let text;
    if (autoPay && !late)
        text = (
            <>
                <span>`We’ll automatically charge ${defaultPaymentMethod.source} for ${currency(invitation.amount).format()} on ${paymentDate.toLocaleDateString(`en-us`, { month: `long`, day: `numeric` })}`</span>
                <span>If you prefer to make a payment now, you can do so below</span>
            </>
        );
    else if (!autoPay && !late)
        text = (
            <>
                <span>{`We’ll notify you on ${paymentDate.toLocaleDateString(`en-us`, { month: `long`, day: `numeric` })} that it’s time to come back and pay ${currency(invitation.amount).format()} `}</span>
                <span>If you prefer to make a payment now, you can do so below</span>
            </>
        );
    else if (late)
        text = `Your payment date has already past this month, but you have outstanding balance. Please make a one time payment below.`;

    return (
        <div className="page-content-wrapper">
            <Congratulations className="h-60" />
            <h1 className="page-header">Congratulations!</h1>
            <span className="page-subheader text-xl">Account setup completed</span>
            <div className="flex flex-col gap-y-2 text-gray-600">
                {text}
            </div>
            {
                late &&
                <div className="pt-4 w-full">
                    <button type="button" className="btn btn-primary">Make a One Time Payment</button>
                </div>
            }
            {
                !late &&
                <div className="pt-4 w-full">
                    <button type="button" className="btn btn-primary" onClick={next}>Go to Dashboard</button>
                </div>
            }
            {
                !late &&
                <button
                    className="background-transparent underline font-bold  px-3 py-1 text-lg outline-none focus:outline-none mr-1 mb-1"
                    type="button"
                    onClick={makePayment}>
                    Make one-time payment
                </button>
            }
        </div>
    );

};

export default SignupCompleted;